const STORAGE_PREFIX = 'odoo-dashboard:saved-filter';

const storageKey = scope => {
  const projectId = typeof localStorage !== 'undefined'
    ? localStorage.getItem('selected_project_id') || 'default'
    : 'default';
  return `${STORAGE_PREFIX}:${projectId}:${scope}`;
};

export const loadDashboardFilter = scope => {
  if (typeof localStorage === 'undefined') return null;
  try {
    const saved = localStorage.getItem(storageKey(scope));
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

export const saveDashboardFilter = (scope, filter) => {
  if (typeof localStorage === 'undefined') return false;
  try {
    localStorage.setItem(storageKey(scope), JSON.stringify(filter));
    return true;
  } catch {
    return false;
  }
};
